export enum LocalStorageKey {
    ContractPageConfig = 'contractPageConfig',
    CatalogPageConfig = 'catalogPageConfig',
    DocumentPageConfig = 'documentPageConfig',
    CustomerPageConfig = 'customerPageConfig',
    UserPageConfig = 'userPageConfig'
}



// WEBPACK FOOTER //
// ./src/app/models/frontend/local-storage.key.ts